import { useRef } from "react";
import { useDimension } from "@/hooks/useDimensions";
import { minMax } from "@/lib/utils";

export function FlowWrapper(props: {
	readonly children: React.ReactNode;
	readonly width: number;
	readonly height: number;
	readonly onPaneClick: (event: React.MouseEvent) => void;
}) {
	const { width, height } = props;

	const myRef = useRef<HTMLDivElement>(null);
	const fitScale = useDimension(myRef, "width");
	const zoom = minMax(fitScale / width, 0.7, 1);

	return (
		<div ref={myRef} className="wunder-diagram-wrapper" onClick={props.onPaneClick}>
			<div className="wunder-diagram" style={{ width, height, zoom }}>
				{props.children}
			</div>
		</div>
	);
}